// Menger sponge: raymarched infinite fractal flight (from the Second Opus demo).
// Used as the "bonus" navigator — the App overlays clickable bonus slots on top.
import type { Scene } from './Engine';
import { HDR, deleteProgram, type Program } from './gl';

const FS = HDR + `
uniform float L;
float map(vec3 p){
  p.xy*=rot(p.z*.035);
  float d=-1e5,s=1.;
  for(int m=0;m<4;m++){vec3 a=mod(p*s,2.)-1.;s*=3.;vec3 r=abs(1.-3.*abs(a));
    float da=max(r.x,r.y),db=max(r.y,r.z),dc=max(r.z,r.x);d=max(d,(min(da,min(db,dc))-1.)/s);}
  return d;
}
void main(){
  vec2 uv=(gl_FragCoord.xy-.5*R)/R.y;
  vec3 ro=vec3(sin(L*.31)*.1,cos(L*.23)*.1,L*1.4);
  vec3 rd=normalize(vec3(uv*(1.+.1*K),1.));
  rd.xy*=rot(L*.1); rd.xz*=rot(sin(L*.19)*.4); rd.yz*=rot(sin(L*.13)*.28);
  float t=.01,d=1.,glow=0.; int i;
  for(i=0;i<90;i++){d=map(ro+rd*t);glow+=exp(-abs(d)*90.);if(d<.0009*t||t>22.)break;t+=d;}
  vec3 fogc=pal(floor(BT)*.13+.6)*.32;
  vec3 col=fogc;
  if(t<22.){
    vec3 p=ro+rd*t; vec2 e=vec2(.0016,0.);
    vec3 n=normalize(vec3(map(p+e.xyy)-map(p-e.xyy),map(p+e.yxy)-map(p-e.yxy),map(p+e.yyx)-map(p-e.yyx)));
    float ao=1.-float(i)/90.;
    vec3 ld=normalize(ro-p);
    float dif=max(dot(n,ld),0.), spc=pow(max(dot(reflect(rd,n),ld),0.),30.);
    vec3 base=mix(vec3(.3,.75,.42),pal(p.z*.03+T*.02),.35);
    col=base*(.15+.85*dif)*ao*ao+spc*.6;
    col+=pal(floor(BT)*.13)*exp(-abs(fract(p.z*.25-BT*.25)-.5)*30.)*(.5+K);
    col=mix(col,fogc,1.-exp(-t*.1));
  }
  col+=fogc*glow*.006*(1.+K);
  O=vec4(col,1.);
}`;

export default function menger(): Scene {
  let p: Program; let l = 0;
  return {
    scale: .6, bloom: 1, crt: .4,
    init(e) { p = e.prog(FS); },
    frame(f) {
      l += f.dt * (0.8 + f.key * 0.6);
      f.e.u(p).f('L', l);
      f.e.fullscreen(p, f);
    },
    dispose(e) { deleteProgram(e.gl, p); },
  };
}
